import 'bootstrap.collapse';
import '/assets/theme/js/mmenu-light.js?v=2';
import { registerComponents } from 'component-utils';
import components from 'core-components';
import 'global';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // Register the components (if applicable).
    if (context instanceof Document && config.registerComponents !== false)
        window.addEventListener('pageshow', () => registerComponents(components));

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const href = link.getAttribute('href');
            const offsetTop = context.querySelector(href).offsetTop;

            window.scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });

    //If sticky box height is greater than device height change it to static
    var stickyBox = document.querySelector('.sticky-box');

    if (stickyBox) {
        if (window.innerWidth >= 991 && document.querySelector('.sticky-box').offsetHeight > window.innerHeight) {
            document.querySelector('.sticky-box').style.position = 'static';
        }
    }

    // plus and minus buttons for shop
    document.querySelectorAll('.adjust-quantity').forEach(button => {
        button.addEventListener('click', () => {
            const closestQuantity = button.closest('.sp-quantity');
            const input = closestQuantity.querySelector('input');

            input.value = +input.value + 1 * +button.getAttribute('data-multi');

            if (+input.value < 0) {
                input.value = 0;
            }
        });
    });

    // Trying to add a delay of the car parts menu hover for each li.
    const listItems = document.querySelectorAll('.dropdown-main .dropdown-menu li');
    let hoverTimeout;
    let currentActive = listItems[0]; // Initially, the first <li> is active

    // Add active class to the first list item by default
    currentActive.classList.add('active');

    listItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            clearTimeout(hoverTimeout);

            // Check if the current item is different from the active one
            if (item !== currentActive && !currentActive.contains(item)) {
                hoverTimeout = setTimeout(() => {
                    // Remove active class from the previously active list item
                    currentActive.classList.remove('active');

                    // Add active class to the hovered list item
                    item.classList.add('active');

                    // Update the current active item
                    currentActive = item;
                }, 100); // Wait for 100 milliseconds before switching
            }
        });

        item.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimeout);
        });
    });

    const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 992px)');

    menu.navigation({
        slidingSubmenus: true,
        title: 'Menu'
    });

    const drawer = menu.offcanvas({
        position: 'left'
    });

    // Open the menu.
    document.querySelector('button[href="#menu-navbar"]')
        .addEventListener('click', (evnt) => {
            evnt.preventDefault();
            drawer.open();
        });
}